/**
 * Functionality for mapbox
 * @version 1.0.0
 */

class Map {
	/**
	 * @constructor
	 * @param {HTMLElement} container container where all results will be displayed
	 * @param {JSON} options option to control the way API will initialize
	 */
	constructor(container, options = {}) {
		this.container = container;

		// Default options to init with if not override by given options
		this.defaultOptions = {
			// mapbox access token
			accessToken: '',

			// mapbox default style
			style: 'mapbox://styles/mapbox/light-v9',

			// zoom
			zoom: 16,
			scroll: false,

			// center map coordinates Latitude and Longitude
			centerLatitude: false,
			centerLongitude: false,

			// All coordinates options
			coordinates: [
				{
					latitude: false,
					longitude: false,
					icon: '',
					iconHeight: '',
					iconWidth: '',
					popup: true,
					autoPopup: false,
					popupHtml: '',
				},
			],
		};

		// Set default options as options to init
		this.options = this.defaultOptions;

		// Get given options
		this.initializedOptions = options;

		// Override options with given
		this.options = Object.assign(this.options, this.initializedOptions);

		// init
		if (this.container) {
			this.initMap(this.container, this.options);
		}
	}

	initMap(element, options) {
		// catch on document...
		document.addEventListener('hello', function (event) {
			// (1)
		});

		let event = new Event('hello', {bubbles: true}); // (2)
		document.dispatchEvent(event);

		this.getMapboxLoad()
			.then((res) => {
				mapboxgl.accessToken = options.accessToken;

				var map = new mapboxgl.Map({
					container: element,
					center: [options.centerLongitude, options.centerLatitude],
					zoom: options.zoom,
					style: options.style,
					dragPan: window.innerWidth > 992 ? true : false,
				});

				map.on('load', () => {
					// Get all localization of markers
					const coordinatesAll = options.coordinates;
					console.log(coordinatesAll);

					// Create geojson for coordinates
					var geojson = {
						type: 'FeatureCollection',
						features: [],
					};

					// Add all coordinates to gjson
					coordinatesAll.forEach((key) => {
						let coordinate = {
							type: 'Feature',
							properties: {
								id: key,
								icon: key.icon,
								iconWidth: key.iconWidth,
								iconHeight: key.iconHeight,
							},
							geometry: {
								type: 'Point',
								coordinates: [key.longitude, key.latitude],
								popupHtml: key.popupHtml,
							},
						};
						geojson.features.push(coordinate);
					});

					// add markers to map
					geojson.features.forEach(function (marker) {
						var el = document.createElement('div');
						el.className = 'marker';
						el.style.backgroundImage = 'url(' + marker.properties.icon + ')';
						el.style.backgroundSize = 'contain';
						el.style.backgroundPosition = 'center';
						el.style.backgroundRepeat = 'no-repeat';
						el.style.width = marker.properties.iconWidth + 'px';
						el.style.height = marker.properties.iconHeight + 'px';

						new mapboxgl.Marker(el)
							.setLngLat(marker.geometry.coordinates)
							.setPopup(new mapboxgl.Popup({offset: 25}).setHTML(marker.geometry.popupHtml))
							.addTo(map);
					});
				});

				map.on('zoom', () => {
					const currentZoom = map.getZoom();
					console.log(currentZoom);
				});

				// disable scroll zoom
				map.scrollZoom.disable();

				// add navigation
				map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
			})
			.catch((e) => {
				console.log(e);
			});
	}

	getMapboxLoad() {
		// (url: String) => Promise[Event]
		function loadLink(url) {
			return new Promise((resolve, reject) => {
				const link = document.createElement('link');
				link.rel = 'stylesheet';
				link.href = url;
				link.addEventListener('error', reject);
				link.addEventListener('load', resolve);

				document.head.appendChild(link);
			});
		}
		// (url: String) => Promise[Mapbox]
		function loadScript(url) {
			return new Promise((resolve, reject) => {
				const script = document.createElement('script');
				script.src = url;
				script.async = false;
				script.addEventListener('error', reject);
				script.addEventListener('load', () => resolve(getMapbox()));

				document.head.appendChild(script);
			});
		}
		// (void) => Promise[Mapbox]
		function getMapbox() {
			return new Promise((resolve, reject) => {
				if (window.mapboxgl) {
					resolve(window.mapboxgl);
				} else {
					reject();
				}
			});
		}
		return new Promise((resolve, reject) =>
			getMapbox()
				.then(resolve)
				.catch(() =>
					Promise.all([
						loadScript('//api.tiles.mapbox.com/mapbox-gl-js/v1.11.1/mapbox-gl.js'),
						loadScript(
							'//api.mapbox.com/mapbox-gl-js/plugins/mapbox-gl-language/v0.10.0/mapbox-gl-language.js'
						),
						loadLink('//api.tiles.mapbox.com/mapbox-gl-js/v1.11.1/mapbox-gl.css'),
					])
						.then(([as]) => resolve(as))
						.catch(reject)
				)
		);
	}
}

export default Map;
